'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var INIT = exports.INIT = 'INIT';
var RESET = exports.RESET = 'RESET';
var CONFIG = exports.CONFIG = 'CONFIG';
var MENUS = exports.MENUS = 'MENUS';
var BRAND = exports.BRAND = 'BRAND';
var GRADIENT = exports.GRADIENT = 'GRADIENT';
var PRODUCT = exports.PRODUCT = 'PRODUCT';
var LOGGED = exports.LOGGED = 'LOGGED';
var LOGOUT = exports.LOGOUT = 'LOGOUT';
var METRIC = exports.METRIC = 'METRIC';
var NOOP = exports.NOOP = 'NOOP';
var NOTIFICATION = exports.NOTIFICATION = 'NOTIFICATION';
var NOTIFICATIONS_SUCCESS = exports.NOTIFICATIONS_SUCCESS = 'NOTIFICATIONS_SUCCESS';
var NOTIFICATIONS_ERROR = exports.NOTIFICATIONS_ERROR = 'NOTIFICATIONS_ERROR';
var NOTIFICATIONS_READ = exports.NOTIFICATIONS_READ = 'NOTIFICATIONS_READ';
var NOTIFICATIONS_UNREAD = exports.NOTIFICATIONS_UNREAD = 'NOTIFICATIONS_UNREAD';
var NOTIFICATIONS_LOADING = exports.NOTIFICATIONS_LOADING = 'NOTIFICATIONS_LOADING';
var SIGNUP = exports.SIGNUP = 'SIGNUP';

var TOGGLE_DROPDOWN = exports.TOGGLE_DROPDOWN = 'TOGGLE_DROPDOWN';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ecs/heimdall/build/types.js
// module id = 25
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38